export enum SignatureType{
    Page = 'page',
    Modal = 'modal'
}
